const environment = {
  baseUrl: "https://api.corplife.at/v0/",
  socketUrl: "https://perfectly-modest-mammal.ngrok-free.app"
};

switch (process.env.REACT_APP_ENV) {
case "development":
  environment.baseUrl = "https://api-dev.corplife.at/v0/";
  environment.socketUrl = "https://api-dev.corplife.at";
  break;
case "staging":
  environment.baseUrl = "https://api-stag.corplife.at/v0/";
  environment.socketUrl = "https://api-stag.corplife.at";
  break;
case "production":
  environment.baseUrl = "https://api.corplife.at/v0/";
  environment.socketUrl = "https://api.corplife.at";
  break;
case "local":
  environment.baseUrl = "http://localhost:8000/v0/";
  environment.socketUrl = "https://perfectly-modest-mammal.ngrok-free.app";
  break;
default:
  environment.baseUrl = "https://api.corplife.at/v0/";
  break;
}

export default environment;
